import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { gatewaysListsResultsAreReadyButEmpty } from "@src/components/pages/gateways-list-page/gateways-component-use-case";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";
import { loadGatewaysMachinesPageData } from "@src/cloud-connect/gateways-with-machines/use-cases/load-gateways-machines-data";

export const useGatewaysData = (isActive: boolean) => {
  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );

  const gatewaysListsResultsReady = useSelector(
    (state: RootState) => state.gatewaysMachinesSlice.resultsReady,
  );

  const connectedGatewaysListData = useSelector(
    (state: RootState) => state.gatewaysMachinesSlice.connectedGatewaysListData,
  );

  const hasGatewayRole =
    authContext &&
    (authContext.permissions.includes("view-gateways") ||
      authContext.permissions.includes("manage-gateways"));

  const error = useSelector(
    (state: RootState) => state.gatewaysMachinesSlice.error,
  );

  useEffect(() => {
    if (!isActive || !hasGatewayRole) return;

    if (!gatewaysListsResultsReady && authContext) {
      loadGatewaysMachinesPageData();
    }
  }, [isActive, hasGatewayRole, gatewaysListsResultsReady, authContext]);

  useEffect(() => {
    if (!isActive || !authContext) return;
    if (hasGatewayRole) return;

    navigateTo(Route.MACHINES);
  }, [isActive, authContext, hasGatewayRole]);

  const getViewState = () => {
    if (!gatewaysListsResultsReady) {
      return "SpinningForData";
    }

    if (!hasGatewayRole) {
      return "SpinningForData";
    }

    if (error) {
      return "Error";
    }

    if (
      gatewaysListsResultsAreReadyButEmpty(
        gatewaysListsResultsReady,
        connectedGatewaysListData,
      )
    ) {
      return "NoGatewaysDetectedView";
    }

    return "GatewaysListsView";
  };

  return {
    viewState: getViewState(),
    hasGatewayRole,
    gatewaysListsResultsReady,
    connectedGatewaysListData,
    error,
  };
};
